<template>
  <div>
    <div class="sign">
      <div class="hor"></div>
      <div class="vert"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Plus'
}
</script>

<style lang="scss" scoped>
.sign {
  position: relative;
  border: 2px solid #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  cursor: pointer;
  background: #fff;
  display: flex;
  justify-items: center;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.24) 0 3px 8px;

  & > div {
    border-top: 4px #4db0ff solid;
    display: block;
    position: absolute;
    width: 30px;
    margin-left: 8px;
  }

  & .vert {
    transform: rotate(90deg);
  }
}
</style>
